<style lang="scss">
html {
  overflow: auto !important;
}

.unauth-action-btn {
  width: 180px !important;
}

.unauth-submit-btn {
  background-color: #002645 !important;
  color: #f5f5f5 !important;
}

.td-list {
  list-style: none;
  padding-left: 0 !important;
  padding-top: 8px;
  padding-bottom: 8px;

  li {
    margin: 2px 0;
  }
}

.link-color {
  color: #1976d2;
}

.small-label-checkbox * {
  font-size: 14px;
}
</style>

<template>
  <div>
    <auth-base v-if="user">
      <router-view />
    </auth-base>
    <unauth-base v-else>
      <router-view />
    </unauth-base>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </div>
</template>

<script>
import AuthBase from '@/components/base/AuthBase';
import UnauthBase from '@/components/unauth/Base';


export default {
  components: {
    AuthBase,
    UnauthBase,
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>
